import { Component, Input } from '@angular/core';
import { AvmDateAndTimePipe } from '@hub4b/pipes/avm-date-and-time.pipe';
import { ByPassSecurityPipe } from '@hub4b/pipes/by-pass-security.pipe ';
import { FolderDocument } from 'src/app/models/server/folder-document';

@Component({
    selector: 'app-email-viewer',
    templateUrl: './email-viewer.component.html',
    styleUrl: './email-viewer.component.scss',
    imports: [AvmDateAndTimePipe, ByPassSecurityPipe]
})
export class EmailViewerComponent {
    /**
     * Valeur indiquant si le fichier selectionné doit être affiché dans la prévisualisation.
     */
    @Input()
    public displayPreview: Boolean = true;

    /**
     * Document E-mail affiché dans le visualisateur.
     */
    @Input()
    public emailDocument: FolderDocument;

    /**
     * Body de l'e-mail.
     */
    @Input()
    public emailBody: string = null;

    /**
     * Expression régulière pour retrouver les séparateurs d'adresses e-mail.
     */
    public addressesDelimiterRegex = /;/g;
}
